import React, { useEffect, useRef, useState } from "react";
import "./RealEstate.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const RealEstate = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Property Management Systems",
      description:
        "Comprehensive software solutions for efficient property management and operations",
      whatsappMessage:
        "Hello, I'm interested in Property Management Systems consultation.",
    },
    {
      id: 2,
      title: "Real Estate CRM",
      description:
        "Customer relationship management tailored for real estate businesses",
      whatsappMessage: "Hello, I'm interested in Real Estate CRM consultation.",
    },
    {
      id: 3,
      title: "Virtual Property Tours",
      description: "Immersive 360° and VR experiences for property showcasing",
      whatsappMessage:
        "Hello, I'm interested in Virtual Property Tours consultation.",
    },
    {
      id: 4,
      title: "Real Estate Analytics",
      description:
        "Data-driven insights for market analysis and investment decisions",
      whatsappMessage:
        "Hello, I'm interested in Real Estate Analytics consultation.",
    },
    {
      id: 5,
      title: "Property Listing Platforms",
      description:
        "Custom websites and apps for property listings and searches",
      whatsappMessage:
        "Hello, I'm interested in Property Listing Platforms consultation.",
    },
    {
      id: 6,
      title: "Smart Home Integration",
      description: "IoT solutions for smart property management and automation",
      whatsappMessage:
        "Hello, I'm interested in Smart Home Integration consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="realestate-page">
      <Helmet>
        <title>
          Real Estate Technology Solutions | Innovative Property Technology
          Services
        </title>
        <meta
          name="description"
          content="Explore our comprehensive real estate technology solutions including property management systems, virtual tours, CRM, and analytics platforms."
        />
        <meta
          name="keywords"
          content="real estate technology, property management, virtual tours, real estate CRM, property analytics, real estate platforms, smart home technology, real estate software, property marketing, real estate investment, property technology, real estate data, property listings, real estate automation, AI in real estate, real estate market trends, property valuation, real estate mobile apps, real estate blockchain, property investment analysis, real estate lead generation, real estate digital transformation, property management systems, real estate SaaS, real estate AI solutions, property tech innovations, real estate predictive analytics, real estate workflow automation, real estate big data, property intelligence platforms"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="realestate-hero">
        <div className="realestate-hero-content">
          <h1 className="realestate-hero-title">
            Transforming{" "}
            <span className="realestate-highlight">Real Estate Technology</span>
          </h1>
          <p className="realestate-hero-description">
            We deliver cutting-edge real estate solutions that transform how
            properties are bought, sold, and managed. From virtual tours to
            property management systems and AI-powered analytics.
          </p>
          <div className="realestate-hero-buttons">
            <a href="/contact-us">
              <button className="realestate-btn realestate-btn-primary">
                Get Started
              </button>
            </a>
            <button className="realestate-btn realestate-btn-secondary">
              Learn More
            </button>
          </div>
        </div>
        <div className="realestate-hero-visual">
          <div className="realestate-animated-building">
            <div className="realestate-building-window"></div>
            <div className="realestate-building-window"></div>
            <div className="realestate-building-window"></div>
            <div className="realestate-building-door"></div>
          </div>
          <div className="realestate-orb realestate-orb-1"></div>
          <div className="realestate-orb realestate-orb-2"></div>
          <div className="realestate-orb realestate-orb-3"></div>
        </div>
      </section>

      {/* Services Section */}
      <section className="realestate-services">
        <div className="realestate-services-header">
          <h2 className="realestate-section-title">
            Our Real Estate Solutions
          </h2>
          <p className="realestate-section-subtitle">
            Innovative property technology services designed to transform your
            real estate operations, enhance customer experiences, and drive
            growth in the digital property market.
          </p>
        </div>

        <div className="realestate-services-grid">
          {/* Property Management Card */}
          <div className="realestate-service-card">
            <div className="realestate-service-icon">
              <div className="realestate-icon realestate-icon-property"></div>
            </div>
            <h3>Property Management Systems</h3>
            <p>
              Comprehensive software for efficient property management, tenant
              tracking, and maintenance scheduling.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Tenant & Lease Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Maintenance Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Rent Collection Automation</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Financial Reporting</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Time Savings</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99%</div>
                <div className="stat-label">Payment Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Real Estate CRM Card */}
          <div className="realestate-service-card">
            <div className="realestate-service-icon">
              <div className="realestate-icon realestate-icon-crm"></div>
            </div>
            <h3>Real Estate CRM</h3>
            <p>
              Specialized customer relationship management for real estate
              agents and brokerages.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Lead Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Follow-ups</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Transaction Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Client Portals</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">35%</div>
                <div className="stat-label">More Leads</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Faster Response</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Virtual Tours Card */}
          <div className="realestate-service-card">
            <div className="realestate-service-icon">
              <div className="realestate-icon realestate-icon-vr"></div>
            </div>
            <h3>Virtual Property Tours</h3>
            <p>
              Immersive 360° and virtual reality experiences for property
              showcasing and remote viewing.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>360° Virtual Tours</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>VR Property Experiences</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Interactive Floor Plans</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Embeddable Tour Widgets</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">5x</div>
                <div className="stat-label">More Engagement</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">49%</div>
                <div className="stat-label">Faster Sales</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Listing Platforms Card */}
          <div className="realestate-service-card">
            <div className="realestate-service-icon">
              <div className="realestate-icon realestate-icon-listing"></div>
            </div>
            <h3>Property Listing Platforms</h3>
            <p>
              Custom websites and mobile apps for property listings, searches,
              and agent connections.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Advanced Search Filters</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Map-Based Browsing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Agent Directory</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Saved Searches & Alerts</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">2.5M</div>
                <div className="stat-label">Monthly Visitors</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">78%</div>
                <div className="stat-label">Mobile Users</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Real Estate Analytics Card */}
          <div className="realestate-service-card">
            <div className="realestate-service-icon">
              <div className="realestate-icon realestate-icon-analytics"></div>
            </div>
            <h3>Real Estate Analytics</h3>
            <p>
              Data-driven insights for market analysis, investment decisions,
              and property valuations.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Market Trend Analysis</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Investment ROI Calculators</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Property Valuation Models</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Neighborhood Analytics</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">95%</div>
                <div className="stat-label">Accuracy</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Better Decisions</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Smart Home Tech Card */}
          <div className="realestate-service-card">
            <div className="realestate-service-icon">
              <div className="realestate-icon realestate-icon-smarthome"></div>
            </div>
            <h3>Smart Home Technology</h3>
            <p>
              IoT solutions for smart property management, home automation, and
              energy efficiency.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Home Automation Systems</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Energy Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Security Integration</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Remote Property Monitoring</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">25%</div>
                <div className="stat-label">Energy Savings</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">15%</div>
                <div className="stat-label">Value Increase</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Investment Platforms Card */}
          <div className="realestate-service-card">
            <div className="realestate-service-icon">
              <div className="realestate-icon realestate-icon-investment"></div>
            </div>
            <h3>Real Estate Investment Platforms</h3>
            <p>
              Technology solutions for property investment, crowdfunding, and
              portfolio management.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Crowdfunding Portals</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Investment Analysis Tools</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Portfolio Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Deal Sourcing Platforms</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">$2.5B</div>
                <div className="stat-label">Transactions</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50K+</div>
                <div className="stat-label">Investors</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Document Management Card */}
          <div className="realestate-service-card">
            <div className="realestate-service-icon">
              <div className="realestate-icon realestate-icon-docs"></div>
            </div>
            <h3>Transaction & Document Management</h3>
            <p>
              Streamlined solutions for real estate transactions, document
              management, and e-signatures.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Digital Transaction Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>E-Signature Solutions</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Document Storage</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Compliance Tracking</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">65%</div>
                <div className="stat-label">Faster Closings</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">90%</div>
                <div className="stat-label">Paper Reduction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="realestate-services-cta">
          <h3>Ready to transform your real estate business?</h3>
          <p>
            Schedule a free consultation with our real estate technology experts
            to discuss your specific needs.
          </p>
          <div className="services-cta-buttons">
            <div className="realestate-consultation-container">
              <button
                className="realestate-primary-btn realestate-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="realestate-modal-overlay">
                  <div className="realestate-modal-content">
                    <button
                      className="realestate-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="realestate-modal-title">
                      Real Estate Technology Consultation
                    </h2>
                    <p className="realestate-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="realestate-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`realestate-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="realestate-option-title">
                            {option.title}
                          </h3>
                          <p className="realestate-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`realestate-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="realestate-btn realestate-btn-secondary">
              View Case Studies
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="realestate-stats">
        <div className="realestate-stats-container">
          <div className="realestate-stat">
            <h3 className="realestate-stat-number" data-count="350">
              350
            </h3>
            <p className="realestate-stat-label">Real Estate Projects</p>
          </div>
          <div className="realestate-stat">
            <h3 className="realestate-stat-number" data-count="97">
              295
            </h3>
            <p className="realestate-stat-label">Client Satisfaction</p>
          </div>
          <div className="realestate-stat">
            <h3 className="realestate-stat-number" data-count="12">
              11
            </h3>
            <p className="realestate-stat-label">Years Experience</p>
          </div>
          <div className="realestate-stat">
            <h3 className="realestate-stat-number" data-count="45">
              45
            </h3>
            <p className="realestate-stat-label">Countries Served</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="realestate-cta">
        <div className="realestate-cta-content">
          <h2>Ready to Transform Your Real Estate Business?</h2>
          <p>
            Contact us today to discuss how our real estate technology expertise
            can help your business innovate and grow.
          </p>
          <a href="/contact-us">
            <button className="realestate-btn realestate-btn-primary realestate-btn-large">
              Schedule a Consultation
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default RealEstate;
